<template>
  <div class="achievements-container">
    <div class="achievements-section">
      <div class="section-header" @click="toggleTodaysAchievements">
        <h3>Today's Achievements</h3>
        <span class="toggle-icon" :class="{ up: !todaysAchievementsOpen }">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            stroke-width="1"
            stroke="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>
        </span>
      </div>
      <transition name="slide-fade">
        <achievements-list
          v-if="todaysAchievementsOpen"
          :locked="false"
          :achievements="todaysAchievements"
          :selected-achievement="selectedAchievement"
          @achievement-selected="onAchievementSelected"
        />
      </transition>
    </div>

    <div class="achievements-section">
      <div class="section-header" @click="toggleLockedAchievements">
        <h3>Locked Achievements</h3>
        <span class="toggle-icon" :class="{ up: !lockedAchievementsOpen }">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            stroke-width="1"
            stroke="currentColor"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
            />
          </svg>
        </span>
      </div>
      <transition name="slide-fade">
        <achievements-list
          v-if="lockedAchievementsOpen"
          :locked="true"
          :achievements="lockedAchievements"
          :selected-achievement="selectedAchievement"
          @achievement-selected="onAchievementSelected"
        />
      </transition>
    </div>
  </div>
</template>

<script>
  import AchievementsList from './achievementList.vue';
  export default {
    name: 'AchievementListSection',
    components: {
      AchievementsList,
    },
    props: {
      todaysAchievements: Array,
      lockedAchievements: Array,
      selectedAchievement: Object,
    },

    data() {
      return {
        todaysAchievementsOpen: true,
        lockedAchievementsOpen: true,
      };
    },

    methods: {
      toggleTodaysAchievements() {
        this.todaysAchievementsOpen = !this.todaysAchievementsOpen;
      },
      toggleLockedAchievements() {
        this.lockedAchievementsOpen = !this.lockedAchievementsOpen;
      },
      onAchievementSelected(achievement) {
        this.$emit('achievement-selected', achievement);
      },
    },
  };
</script>

<style scoped>
  .achievements-section {
    margin: 10px 0;
    background-color: rgba(76, 76, 103, 1);
    overflow: hidden;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 20px;
    cursor: pointer;
  }

  .section-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
  }

  .toggle-icon {
    font-size: 14px;
    transition: transform 0.3s ease;
  }

  .toggle-icon.up {
    transform: rotate(180deg);
  }

  .achievements-list {
    padding: 10px;
  }

  .achievement-item {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    border-bottom: 1px solid rgba(173, 173, 235, 0.1);
  }

  .achievement-item:last-child {
    border-bottom: none;
  }

  .achievement-icon {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-right: 15px;
  }

  .achievement-details {
    flex: 1;
  }

  .achievement-title {
    font-weight: 600;
    margin-bottom: 4px;
  }

  .achievement-description {
    font-size: 14px;
    color: #8d8f97;
  }

  .achievement-stars {
    margin-left: 10px;
  }

  .star {
    color: rgba(147, 147, 236, 1);
    font-size: 16px;
  }

  .achievement-item.locked {
    opacity: 0.7;
  }

  .achievement-icon.locked {
    filter: grayscale(1);
  }

  .star.locked {
    color: #555;
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.6s ease;
    transform-origin: top;
  }

  .slide-fade-enter-from,
  .slide-fade-leave-to {
    transform: scaleY(0);
    max-height: 0;
    opacity: 0;
  }

  .slide-fade-enter-to,
  .slide-fade-leave-from {
    transform: scaleY(1);
    max-height: 700px;
    opacity: 1;
  }
</style>
